import React, { useEffect, useState } from "react";
import { Button, Col, Collapse, Flex, Input, Row, Spin, theme } from "antd";
import { CiSearch } from "react-icons/ci";
import { GoPlus } from "react-icons/go";
import { MdKeyboardArrowDown } from "react-icons/md";
import { BsChevronExpand } from "react-icons/bs";
import BookImage from "../../assets/book.png";
import Book2Image from "../../assets/book_2.png";
import StarImage from "../../assets/star.png";
import StudentPerformanceCard from "../../components/Cards/StudentPerformanceCard";
import TeacherCard from "../../components/Cards/TeacherCard";
import { useNavigate } from "react-router-dom";
import { getAllTeachersList } from "../../store/services/teacher";
import TargetModelAdmin from "../../components/Modals/targetModal/targetModalAdmin";
import SearchableDropdown from "../../components/SearchableDropdown";
import { getLearningapi } from "../../store/services/curriculum";
import { IoIosArrowDown } from "react-icons/io";
import { getAllSubject } from "../../store/services/subject";
import { getAllStudents } from "../../store/services/student";
import StudentSignupModal from "../../components/Modals/studentModal/StudentSignupModal";
import TeacherSignupModal from "../../components/Modals/Teachers/TeacherSignupModal";
import { useAppSelector } from "../../store/hooks";
import Loading from "../../components/Loading/Loading";
import { getTopFerformerBySubject } from "../../store/services/state";

const panelStyle = {
  marginBottom: 24,
  background: "#ffffff",
  borderRadius: "8px",
  border: "none",
};
const panelStyle2 = {
  marginBottom: 24,
  background: "#ffffff",
  borderRadius: "8px",
  border: "none",
  fontSize: "10px",
  // color:"red"
};

const openCloseIcon = (isActive: any) => {
  return isActive ? (
    <MdKeyboardArrowDown style={{ width: "20px", height: "20px" }} />
  ) : (
    <BsChevronExpand style={{ width: "20px", height: "20px" }} />
  );
};

const AdminDashboard = () => {
  const { Panel } = Collapse;
  const navigate = useNavigate();
  const [teacher, setTeacher] = useState([]);
  const [totalTeachers, setTotalTeachers] = useState<number>(0);
  const [isModalOpens, setIsModalOpens] = useState(false);
  const [currentModule, setCurrentModule] = useState<number | null>(null);
  const [activeItem, setActiveItem] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchValue, setFetchValue] = useState([]);
  const [levels, setLevels] = useState<any>([]);
  const [targets, setTarget] = useState<any>([]);
  const [defaultValue, setDefaultValue] = useState<string>("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [isAddTeacherModalVisible, setIsAddTeacherModalVisible] =
    useState<boolean>(false);
  const [isAddStudentModalVisible, setIsAddStudentModalVisible] =
    useState<boolean>(false);
  const [totalStudents, setTotalStudents] = useState<number>(0);
  const [currentLevelId, setCurrentLevelId] = useState<number>();
  const currentYear = new Date().getFullYear();
  const [topPerformer, setTopPerformer] = useState([]);
  const { loading } = useAppSelector((state) => state.states);
  const teachersLoading = useAppSelector(
    (state) => state.teacher.loadingTeachers
  );

  const { token } = theme.useToken();

  const handleMOdal = () => {
    setIsModalOpens(true);
  };
  useEffect(() => {
    sendData();
  }, []);

  useEffect(() => {
    const getTopPErformers = async () => {
      const response = await getTopFerformerBySubject({
        search: "",
        classId: "",
        subjectId: "",
        // year: currentYear,
        page: 1,
        perPage: 3,
      });
      if (response && response?.monitoringList) {
        setTopPerformer(response.monitoringList);
      }
    };
    getTopPErformers();
  }, []);

  const sendData = async () => {
    const getSub = await getAllSubject(0, 10, "", "active");

    if (getSub) {
      setIsLoading(true);
      setDefaultValue(getSub.subjectList[0].subjectName);
      const payload = {
        subjectId: Number(getSub.subjectList[0].subjectId),
      };

      const response = await getLearningapi(payload);
      setCurrentModule(getSub.subjectList[0].subjectId);

      if (response) {
        setIsLoading(true);
        const newLevels = response.newLevelList.map((newLevel: any) => {
          const modules = newLevel.modules.map((module: any) => ({
            name: module.moduleName,
            targets: module.lessonsList.map((lesson: any) => lesson),
            moduleId: module.moduleId,
            status: module.status,
          }));

          const { levelId } = newLevel;
          setCurrentLevelId(newLevel.levelId);
          return {
            level: newLevel.levelName,
            status: newLevel.status,
            modules: modules,
            levelId: levelId,
          };
        });
        setLevels(newLevels);
        setTarget(newLevels);
      }
      setIsLoading(false);
    }
    setActiveItem(false);
  };

  const onChange = async (e: any) => {
    const findClass: any = fetchValue.find((item: any) => {
      return e === item.subjectId;
    });
    setDefaultValue(findClass.subjectName);
    setLevels([]);
    setIsLoading(true);
    const payload = {
      subjectId: findClass.subjectId,
    };
    setCurrentModule(findClass.subjectId);
    const response = await getLearningapi(payload);
    if (response) {
      setIsLoading(true);
      const newLevels = response.newLevelList.map((newLevel: any) => {
        const modules = newLevel.modules.map((module: any) => ({
          name: module.moduleName,
          targets: module.lessonsList.map((lesson: any) => lesson),
          moduleId: module.moduleId,
        }));

        const { levelId } = newLevel;
        setCurrentLevelId(newLevel.levelId);
        return {
          level: newLevel.levelName,
          modules: modules,
          levelId: levelId,
        };
      });
      setLevels(newLevels);
      setTarget(newLevels);
    }
    setIsLoading(false);
    setActiveItem(false);
  };

  const fetchTeachers = async () => {
    try {
      const payload = {
        page: 0,
        perPage: 3,
      };
      const res = await getAllTeachersList(payload);
      setTeacher(res?.records);
      setTotalTeachers(res?.count);
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchStudents = async () => {
    try {
      const payload = {
        page: 1,
        perPage: 0,
      };
      const res = await getAllStudents(payload);
      setTotalStudents(res?.count);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getData = async () => {
    setLevels([]);
    setIsLoading(true);
    setActiveItem(true);
    const payload = {
      subjectId: Number(currentModule),
    };

    const response = await getLearningapi(payload);
    if (response) {
      setIsLoading(true);
      const newLevels = response.newLevelList.map((newLevel: any) => {
        const modules = newLevel.modules.map((module: any) => ({
          name: module.moduleName,
          targets: module.lessonsList.map((lesson: any) => lesson),
          moduleId: module.moduleId,
        }));

        const { levelId } = newLevel;
        setCurrentLevelId(newLevel.levelId);
        return {
          level: newLevel.levelName,
          modules: modules,
          levelId: levelId,
        };
      });
      setLevels(newLevels);
      setTarget(newLevels);
    }
    setIsLoading(false);
    setActiveItem(false);
  };

  useEffect(() => {
    fetchTeachers();
    fetchStudents();
    // setLevels([]);
    // setCurrentModule('')
    getData();
  }, [refreshKey]);

  const handleKey = () => {
    setRefreshKey((prevKey) => prevKey + 1);
    setIsModalOpens(false);
  };

  return (
    <>
      <TeacherSignupModal
        visible={isAddTeacherModalVisible}
        onCancel={setIsAddTeacherModalVisible}
        fetchTeachers={fetchTeachers}
      />
      <StudentSignupModal
        visible={isAddStudentModalVisible}
        onCancel={setIsAddStudentModalVisible}
        fetchStudents={fetchStudents}
      />

      <div className="dashboard_container">
        <Row>
          <Col
            className="admin_dash_col"
            lg={{ order: 1, span: 18 }}
            sm={{ order: 2, span: 24 }}
          >
            <div className="left_column green-scrollbar">
              <div className="wrapper">
                <div className="header">
                  <div className="top">
                    <p className="title">Welcome back! 👋🏼</p>
                    <p className="desc">Review and manage the school data</p>
                  </div>

                  <div className="bottom">
                    <Input
                      size="large"
                      placeholder="Search..."
                      className="dashboard_search"
                      prefix={<CiSearch />}
                    />
                  </div>
                </div>

                {/* cards container */}
                <div className="dashboard_cards_container">
                  <div className="dashboard_card">
                    <img
                      src={BookImage}
                      alt="book_image"
                      className="book_image"
                    />
                    <img
                      src={StarImage}
                      alt="star_image"
                      className="star_image"
                    />
                    <div className="top">
                      <p className="label">Total Students Number</p>
                      <p className="value additionalValueClass">
                        {totalStudents}
                      </p>
                    </div>
                    <Button
                      className="card_add_btn"
                      onClick={() => setIsAddStudentModalVisible(true)}
                    >
                      <GoPlus /> Add
                    </Button>
                  </div>

                  <div className="dashboard_card dashboard_card_2">
                    <img
                      src={Book2Image}
                      alt="book_2_image"
                      className="book_image"
                    />
                    <img
                      src={StarImage}
                      alt="star_image"
                      className="star_image"
                    />
                    <div className="top">
                      <p className="label">Total Teachers Number</p>
                      <p className="value additionalValueClass">
                        {totalTeachers}
                      </p>
                    </div>
                    <Button
                      className="card_add_btn"
                      onClick={() => setIsAddTeacherModalVisible(true)}
                    >
                      <GoPlus />
                      Add
                    </Button>
                  </div>
                </div>

                {/* Performers */}
                <div className="performers_main_container">
                  <div className="performance_header">
                    <p className="label">Top Performers</p>
                    <p
                      className="view-all"
                      onClick={() => {
                        navigate("/dashboard/top-performers");
                      }}
                    >
                      View All
                    </p>
                  </div>
                  <div className="cards">
                    {loading ? (
                      <Loading />
                    ) : topPerformer?.length > 0 ? (
                      topPerformer?.map((item: any) => {
                        return (
                          <>
                            <StudentPerformanceCard
                              key={item?.name}
                              data={item}
                            />
                          </>
                        );
                      })
                    ) : (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <p>No data available!</p>
                      </div>
                    )}
                  </div>
                </div>

                <div className="performers_main_container">
                  <div className="performance_header">
                    <p className="label">Teachers</p>
                    <p
                      className="view-all"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate("/teachers");
                      }}
                    >
                      View All
                    </p>
                  </div>
                  <div className="cards">
                    {teachersLoading ? (
                      <Loading />
                    ) : teacher?.length > 0 ? (
                      teacher?.map((item: any) => {
                        return <TeacherCard key={item?.name} data={item} />;
                      })
                    ) : (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <p>No data available!</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col
            xs={{ order: 2, span: 24 }}
            lg={{ order: 2, span: 6 }}
            sm={{ order: 1, span: 24 }}
          >
            <div className="right_column">
              <p className="column_title">Targets</p>
              <div className="targets_container green-scrollbar">
                <div style={{ marginBottom: "10px" }}>
                  <SearchableDropdown
                    onChange={onChange}
                    setFetchedOptions={setFetchValue}
                    url="/subject/get-all"
                    mode={false}
                    placeholder="Search by subject name"
                    columns={["subjectName"]}
                    type="subject"
                    defaultValue={defaultValue}
                    params={{ status: "active" }}
                  />
                </div>

                {isLoading ? (
                  <Flex
                    align="center"
                    justify="center"
                    style={{ height: "50vh" }}
                    gap="middle"
                  >
                    <Spin size="large" />
                  </Flex>
                ) : !currentModule ? (
                  <h1 style={{ textAlign: "center" }}>Select Target</h1>
                ) : (
                  <Collapse
                    className="custom_dashboard_collapse"
                    bordered={false}
                    expandIcon={({ isActive }) => openCloseIcon(isActive)}
                    style={{ background: "transparent" }}
                  >
                    {levels.length > 0 ? (
                      levels
                        .filter((level: any) => level?.status === "active")
                        .map((level: any, index: number) => (
                          <Panel
                            header={level.level}
                            key={index}
                            style={panelStyle}
                          >
                            <Collapse
                              bordered={false}
                              expandIcon={({ isActive }) => (
                                <IoIosArrowDown
                                  size={20}
                                  className={`arrow-icon ${
                                    isActive ? "rotate" : ""
                                  }`}
                                />
                              )}
                              style={{ background: token.colorBgContainer }}
                              accordion
                              className="_innerCollapse"
                            >
                              {level?.modules
                                ?.filter(
                                  (module: any) => module?.status === "active"
                                )
                                .map((module: any, i: number) => (
                                  <Panel
                                    key={module?.name}
                                    header={module?.name}
                                    style={panelStyle2}
                                    className="innerpanel"
                                  >
                                    <ul
                                      style={{ paddingLeft: "1px" }}
                                      className="custom-list"
                                    >
                                      {module?.targets?.map(
                                        (lesson: any, i: number) => {
                                          if (lesson?.status === "active") {
                                            return (
                                              <li
                                                key={i}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "black",
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {lesson?.lessonName}
                                              </li>
                                            );
                                          }
                                        }
                                      )}
                                    </ul>
                                  </Panel>
                                ))}
                            </Collapse>
                          </Panel>
                        ))
                    ) : (
                      <p style={{ textAlign: "center", color: "gray" }}>
                        No lessons available
                      </p>
                    )}
                  </Collapse>
                )}
              </div>
              <Button
                className="add_target_btn"
                onClick={handleMOdal}
                disabled={activeItem}
              >
                <GoPlus /> Add Target
              </Button>

              <TargetModelAdmin
                isModalOpens={isModalOpens}
                currentModule=" "
                setIsModalOpens={setIsModalOpens}
                onAddTarget={targets}
                getData={handleKey}
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AdminDashboard;
